import { mount } from './dom-lifecycle';

function bootNav(nav) {
    if (nav.dataset.navBooted === '1') return;
    nav.dataset.navBooted = '1';

    const toggle = nav.querySelector('[data-nav-toggle]');

    const setOpen = (open) => {
        nav.classList.toggle('is-open', open);
        document.body.classList.toggle('nav-open', open);
        toggle?.setAttribute('aria-expanded', String(open));
        toggle?.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
    };

    toggle?.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));

    nav.querySelectorAll('.site-nav__menu a').forEach((link) => {
        link.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
            setOpen(false);
            toggle?.focus();
        }
    });

    initScrollSpy(nav);
}

// Podświetla w menu link sekcji, która jest aktualnie oglądana (zmiana koloru na złoty).
// Bierze pod uwagę tylko linki-kotwice (#...) wskazujące na istniejące sekcje.
function initScrollSpy(nav) {
    const items = Array.from(nav.querySelectorAll('.site-nav__menu a[href^="#"]'))
        .map((link) => {
            const id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
            const section = id ? document.getElementById(id) : null;
            return section ? { link, section } : null;
        })
        .filter(Boolean);

    if (!items.length) return;

    let ticking = false;

    const update = () => {
        ticking = false;
        // Linia odniesienia tuż pod przyklejonym menu. Aktywna = sekcja, której górna
        // krawędź minęła linię i jest jej NAJBLIŻSZA (największy top ≤ linia) — czyli ta
        // aktualnie oglądana. Liczymy po pozycji na stronie, nie po kolejności linków w menu
        // (kolejność sekcji w DOM bywa inna niż kolejność pozycji menu).
        const line = window.innerHeight * 0.3;
        let active = null;
        let activeTop = -Infinity;
        items.forEach((item) => {
            const top = item.section.getBoundingClientRect().top;
            if (top <= line && top > activeTop) {
                active = item;
                activeTop = top;
            }
        });
        items.forEach(({ link }) => link.classList.toggle('is-active', active !== null && active.link === link));
    };

    const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
}

export function initNav() {
    mount('[data-nav]', bootNav);
}

initNav();
